import { useMemo } from "react";
import PropTypes from "prop-types";
import { tagular } from "@cohesion/tagular";

import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";

import { ArrowRight } from "@icons/arrowRight";
import { Button } from "@components/button";
import { ImgixNextImage } from "@components/imgixNextImage";
import { ImgixNextBackground } from "@components/imgixNextBackground";

export function Shop({ title = "Get the book", btnText = "Buy now" }) {
  const { screen } = useBestInTravel();
  const isSmallScreen = ["sm"].includes(screen);

  const topographyBackgroundProps = useMemo(
    () => ({
      overlay: "custom",
      wrapperClasses: "w-full",
      imageClasses: "bg-sand-200 object-bottom",
      src: isSmallScreen
        ? "https://lonelyplanetstatic.imgix.net/marketing/best-in-travel/2025/topography-background-shop-sm.svg"
        : "https://lonelyplanetstatic.imgix.net/marketing/best-in-travel/2025/topography-background-shop.svg",
    }),
    [isSmallScreen]
  );

  return (
    <ImgixNextBackground {...topographyBackgroundProps}>
      <div className="flex flex-col items-center justify-center h-full">
        <h3 className="text-lg font-extrabold font-neue text-blue">Shop</h3>
        <p className="pb-10 mx-auto text-4xl font-normal text-center md:text-5xl font-instrument text-blue md:max-w-full ">
          {title}
        </p>
        <ImgixNextImage
          src="https://lonelyplanetstatic.imgix.net/marketing/best-in-travel/2025/best-in-travel-cover-large.jpg"
          alt="Book Best In Travel 2025"
          width={isSmallScreen ? 258 : 289}
          height={isSmallScreen ? 324 : 363}
          quality={75}
          imgixParams={{
            w: isSmallScreen ? 258 : 289,
            h: isSmallScreen ? 324 : 363,
          }}
          className="mx-auto"
        />
        <Button
          className="flex items-center w-auto h-10 gap-4 mt-8 btn btn-primary"
          href="https://shop.lonelyplanet.com/products/lonely-planets-best-in-travel-2025-book"
          onClick={() => {
            tagular("product_click", {
              actionOutcome: "EXTERNAL LINK",
              correlationId: "",
              outboundUrl:
                "https://shop.lonelyplanet.com/products/lonely-planets-best-in-travel-2025-book",
              product: {
                location: "BIT_Book_Section MODULE_SHOP",
                text: btnText,
                position: 0,
                brand: "shop",
              },
            });
          }}
        >
          {btnText}
          <ArrowRight className="inline-block text-lg -rotate-45" />
        </Button>
      </div>
    </ImgixNextBackground>
  );
}

Shop.propTypes = {
  title: PropTypes.string,
  btnText: PropTypes.string,
};
